import {PortfolioPayload} from '../util'

export const createPortfolio = (name) => ({apis, getState}) => {
  const data = {...PortfolioPayload, name: name}
  const payload = apis.savePortfolio(data).map((x) => x)
  return {
    type: 'CREATE_PORTFOLIO',
    payload,
    data,
  }
}

export const deletePortfolio = (data) => ({apis, getState}) => {
  const portfolioId = getState().monitoring.selectedPortfolio
  const payload = apis.deletePortfolio(portfolioId).map((x) => x)
  return {
    type: 'DELETE_PORTFOLIO',
    data: portfolioId,
    payload,
  }
}

export const resetError = () => {
  return {
    type: 'RESET_MODAL_ERROR',
  }
}
export const updateTranslations = ({updatedText, resourceId, index, locale, resourceSet}) => ({apis, getState}) => {
  const data = {resourceId: resourceId, trans: updatedText, resourceSet: resourceSet}
  const csUserId = getState().app.csUserId
  const payload = apis.saveTranslations(locale, csUserId)([data]).map((x) => x)
  return {
    type: 'UPDATE_TRANSLATIONS',
    payload,
    updatedText,
    resourceId,
    index,
  }
}



// WEBPACK FOOTER //
// ./src/store/modal/actions.js